<template>
  <f7-page no-toolbar no-navbar no-swipeback>
    <p class="text-align-center">
      <img :src="require('@/assets/logo.png')" alt="Logo" class="logo">
    </p>
    <f7-block strong class="mb-0" inset>
      <p class="text-align-center">
        <img :src="require('@/assets/images/maintenance.jpg')" alt="Maintenance" style="max-width: 90%;">
      </p>
      <p class="text-align-center">
        Hệ thống hiện đang được bảo trì.<br/>Quý Khách vui lòng quay lại sau
      </p>
    </f7-block>
    <p class="text-align-center text-color-white-opacity text-small">v{{ $store.state.app_version }}</p>
  </f7-page>
</template>
<script>

export default {
};
</script>
<style scoped>
img.logo {
  height : 72px;
}
.text-color-white-opacity {
  color : rgba(238, 235, 235, 0.8) !important;
}
.text-small {
  font-size : 12px;
}
</style>
